/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddBulkDashboardUser } from '../models/AddBulkDashboardUser';
import type { AddNewDashboardUser } from '../models/AddNewDashboardUser';
import type { AddOrRemoveRequestItems } from '../models/AddOrRemoveRequestItems';
import type { CompanyFileStorageReferenceUpdate } from '../models/CompanyFileStorageReferenceUpdate';
import type { CompanyMeasurementDateFileStorageReferenceUpdate } from '../models/CompanyMeasurementDateFileStorageReferenceUpdate';
import type { CompanyPrimaryContact } from '../models/CompanyPrimaryContact';
import type { CompanyRequestedDocumentModel } from '../models/CompanyRequestedDocumentModel';
import type { CompanyRequestedInformation } from '../models/CompanyRequestedInformation';
import type { Create409Report } from '../models/Create409Report';
import type { CreateCompanyInformationRequest } from '../models/CreateCompanyInformationRequest';
import type { DraftFinalReportEmailRequest } from '../models/DraftFinalReportEmailRequest';
import type { DraftFinalReportEmailResponse } from '../models/DraftFinalReportEmailResponse';
import type { EnsureFulfillmentForAttioValuationRequest } from '../models/EnsureFulfillmentForAttioValuationRequest';
import type { FileStorageReferenceResponse } from '../models/FileStorageReferenceResponse';
import type { Fulfillment } from '../models/Fulfillment';
import type { FulfillmentAssignmentRule } from '../models/FulfillmentAssignmentRule';
import type { FulfillmentModelLeaderboardQuery } from '../models/FulfillmentModelLeaderboardQuery';
import type { GoogleCalendarEventsQuery } from '../models/GoogleCalendarEventsQuery';
import type { LatestValuationExtractionRun } from '../models/LatestValuationExtractionRun';
import type { NumberFriendlyCreateCompanyQuestion } from '../models/NumberFriendlyCreateCompanyQuestion';
import type { ReportBackupFile } from '../models/ReportBackupFile';
import type { ReportContact } from '../models/ReportContact';
import type { ScalarOpinionView } from '../models/ScalarOpinionView';
import type { StartValuationExtractionResponse } from '../models/StartValuationExtractionResponse';
import type { TableView } from '../models/TableView';
import type { TableViewListResponse } from '../models/TableViewListResponse';
import type { UpdateCompanyQuestion } from '../models/UpdateCompanyQuestion';
import type { UpdateScalarOpinionClientsAuthorized } from '../models/UpdateScalarOpinionClientsAuthorized';
import type { UserFulfillmentRequest } from '../models/UserFulfillmentRequest';
import type { ValuationExtractionStatus } from '../models/ValuationExtractionStatus';
import type { ValuationOpinionModule } from '../models/ValuationOpinionModule';
import type { ValuationReportSelection } from '../models/ValuationReportSelection';
import type { WorkboardDirectory } from '../models/WorkboardDirectory';
import type { WorkboardEmailTemplate } from '../models/WorkboardEmailTemplate';
import type { WorkboardEmailTemplateListResponse } from '../models/WorkboardEmailTemplateListResponse';
import type { WorkboardPrefixExists } from '../models/WorkboardPrefixExists';
import type { WorkboardTask } from '../models/WorkboardTask';
import type { WorkboardTaskCalendarEventsQuery } from '../models/WorkboardTaskCalendarEventsQuery';
import type { WorkboardTaskOccurrence } from '../models/WorkboardTaskOccurrence';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DashboardService {
  /**
   * @param data
   * @returns Create409Report
   * @throws ApiError
   */
  public static apiDashboardCreate(
    data: Create409Report,
  ): CancelablePromise<Create409Report> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard',
      body: data,
    });
  }
  /**
   * @param questionId
   * @returns UpdateCompanyQuestion
   * @throws ApiError
   */
  public static apiDashboardCompaniesCompanyQuestionRead(
    questionId: string,
  ): CancelablePromise<UpdateCompanyQuestion> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/companies/company-question/{question_id}',
      path: {
        'question_id': questionId,
      },
    });
  }
  /**
   * @param questionId
   * @param data
   * @returns UpdateCompanyQuestion
   * @throws ApiError
   */
  public static apiDashboardCompaniesCompanyQuestionUpdate(
    questionId: string,
    data: UpdateCompanyQuestion,
  ): CancelablePromise<UpdateCompanyQuestion> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/dashboard/companies/company-question/{question_id}',
      path: {
        'question_id': questionId,
      },
      body: data,
    });
  }
  /**
   * @param questionId
   * @param data
   * @returns UpdateCompanyQuestion
   * @throws ApiError
   */
  public static apiDashboardCompaniesCompanyQuestionPartialUpdate(
    questionId: string,
    data: UpdateCompanyQuestion,
  ): CancelablePromise<UpdateCompanyQuestion> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/dashboard/companies/company-question/{question_id}',
      path: {
        'question_id': questionId,
      },
      body: data,
    });
  }
  /**
   * @param questionId
   * @returns void
   * @throws ApiError
   */
  public static apiDashboardCompaniesCompanyQuestionDelete(
    questionId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/dashboard/companies/company-question/{question_id}',
      path: {
        'question_id': questionId,
      },
    });
  }
  /**
   * @param requestedDocumentId
   * @returns CompanyRequestedDocumentModel
   * @throws ApiError
   */
  public static apiDashboardCompaniesCompanyRequestedDocumentRead(
    requestedDocumentId: string,
  ): CancelablePromise<CompanyRequestedDocumentModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/companies/company-requested-document/{requested_document_id}',
      path: {
        'requested_document_id': requestedDocumentId,
      },
    });
  }
  /**
   * @param requestedDocumentId
   * @param data
   * @returns CompanyRequestedDocumentModel
   * @throws ApiError
   */
  public static apiDashboardCompaniesCompanyRequestedDocumentUpdate(
    requestedDocumentId: string,
    data: CompanyRequestedDocumentModel,
  ): CancelablePromise<CompanyRequestedDocumentModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/dashboard/companies/company-requested-document/{requested_document_id}',
      path: {
        'requested_document_id': requestedDocumentId,
      },
      body: data,
    });
  }
  /**
   * @param requestedDocumentId
   * @param data
   * @returns CompanyRequestedDocumentModel
   * @throws ApiError
   */
  public static apiDashboardCompaniesCompanyRequestedDocumentPartialUpdate(
    requestedDocumentId: string,
    data: CompanyRequestedDocumentModel,
  ): CancelablePromise<CompanyRequestedDocumentModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/dashboard/companies/company-requested-document/{requested_document_id}',
      path: {
        'requested_document_id': requestedDocumentId,
      },
      body: data,
    });
  }
  /**
   * @param requestedDocumentId
   * @returns void
   * @throws ApiError
   */
  public static apiDashboardCompaniesCompanyRequestedDocumentDelete(
    requestedDocumentId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/dashboard/companies/company-requested-document/{requested_document_id}',
      path: {
        'requested_document_id': requestedDocumentId,
      },
    });
  }
  /**
   * @param data
   * @returns AddBulkDashboardUser
   * @throws ApiError
   */
  public static apiDashboardCompanyAddBulkUserCreate(
    data: AddBulkDashboardUser,
  ): CancelablePromise<AddBulkDashboardUser> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/company/add-bulk-user/',
      body: data,
    });
  }
  /**
   * @param data
   * @returns AddNewDashboardUser
   * @throws ApiError
   */
  public static apiDashboardCompanyAddUserCreate(
    data: AddNewDashboardUser,
  ): CancelablePromise<AddNewDashboardUser> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/company/add-user/',
      body: data,
    });
  }
  /**
   * @param cmdId
   * @param data
   * @returns UpdateScalarOpinionClientsAuthorized
   * @throws ApiError
   */
  public static apiDashboardCompanyApproveForClientsUpdate(
    cmdId: string,
    data: UpdateScalarOpinionClientsAuthorized,
  ): CancelablePromise<UpdateScalarOpinionClientsAuthorized> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/dashboard/company/approve-for-clients/{cmd_id}',
      path: {
        'cmd_id': cmdId,
      },
      body: data,
    });
  }
  /**
   * @param cmdId
   * @param data
   * @returns UpdateScalarOpinionClientsAuthorized
   * @throws ApiError
   */
  public static apiDashboardCompanyApproveForClientsPartialUpdate(
    cmdId: string,
    data: UpdateScalarOpinionClientsAuthorized,
  ): CancelablePromise<UpdateScalarOpinionClientsAuthorized> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/dashboard/company/approve-for-clients/{cmd_id}',
      path: {
        'cmd_id': cmdId,
      },
      body: data,
    });
  }
  /**
   * @param data
   * @returns NumberFriendlyCreateCompanyQuestion
   * @throws ApiError
   */
  public static apiDashboardCompanyCreateQuestionsCreate(
    data: NumberFriendlyCreateCompanyQuestion,
  ): CancelablePromise<NumberFriendlyCreateCompanyQuestion> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/company/create-questions/',
      body: data,
    });
  }
  /**
   * @param data
   * @returns CompanyRequestedDocumentModel
   * @throws ApiError
   */
  public static apiDashboardCompanyCreateRequestedDocumentsCreate(
    data: CompanyRequestedDocumentModel,
  ): CancelablePromise<CompanyRequestedDocumentModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/company/create-requested-documents/',
      body: data,
    });
  }
  /**
   * @param data
   * @returns AddOrRemoveRequestItems
   * @throws ApiError
   */
  public static apiDashboardCompanyModifyExistingRequestCreate(
    data: AddOrRemoveRequestItems,
  ): CancelablePromise<AddOrRemoveRequestItems> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/company/modify-existing-request/',
      body: data,
    });
  }
  /**
   * @param data
   * @returns CompanyPrimaryContact
   * @throws ApiError
   */
  public static apiDashboardCompanyPrimaryContactCreate(
    data: CompanyPrimaryContact,
  ): CancelablePromise<CompanyPrimaryContact> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/company/primary-contact/',
      body: data,
    });
  }
  /**
   * @param companyId
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiDashboardCompanyRead(
    companyId: string,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<ScalarOpinionView>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/company/{company_id}',
      path: {
        'company_id': companyId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param companyId
   * @param data
   * @returns CreateCompanyInformationRequest
   * @throws ApiError
   */
  public static apiDashboardCompanyCreateInformationRequestCreate(
    companyId: string,
    data: CreateCompanyInformationRequest,
  ): CancelablePromise<CreateCompanyInformationRequest> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/company/{company_id}/create-information-request/',
      path: {
        'company_id': companyId,
      },
      body: data,
    });
  }
  /**
   * Override list to return enhanced fulfillment data with user details
   * @param companyId
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiDashboardCompanyOperationsFulfillmentList(
    companyId: string,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<Fulfillment>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/company/{company_id}/operations/fulfillment/',
      path: {
        'company_id': companyId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param companyId
   * @param data
   * @returns Fulfillment
   * @throws ApiError
   */
  public static apiDashboardCompanyOperationsFulfillmentCreate(
    companyId: string,
    data: Fulfillment,
  ): CancelablePromise<Fulfillment> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/company/{company_id}/operations/fulfillment/',
      path: {
        'company_id': companyId,
      },
      body: data,
    });
  }
  /**
   * @param companyId
   * @param attioValuationId
   * @returns Fulfillment
   * @throws ApiError
   */
  public static apiDashboardCompanyOperationsFulfillmentRead(
    companyId: string,
    attioValuationId: string,
  ): CancelablePromise<Fulfillment> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/company/{company_id}/operations/fulfillment/{attio_valuation_id}/',
      path: {
        'company_id': companyId,
        'attio_valuation_id': attioValuationId,
      },
    });
  }
  /**
   * @param companyId
   * @param attioValuationId
   * @param data
   * @returns Fulfillment
   * @throws ApiError
   */
  public static apiDashboardCompanyOperationsFulfillmentUpdate(
    companyId: string,
    attioValuationId: string,
    data: Fulfillment,
  ): CancelablePromise<Fulfillment> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/dashboard/company/{company_id}/operations/fulfillment/{attio_valuation_id}/',
      path: {
        'company_id': companyId,
        'attio_valuation_id': attioValuationId,
      },
      body: data,
    });
  }
  /**
   * @param companyId
   * @param attioValuationId
   * @param data
   * @returns Fulfillment
   * @throws ApiError
   */
  public static apiDashboardCompanyOperationsFulfillmentPartialUpdate(
    companyId: string,
    attioValuationId: string,
    data: Fulfillment,
  ): CancelablePromise<Fulfillment> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/dashboard/company/{company_id}/operations/fulfillment/{attio_valuation_id}/',
      path: {
        'company_id': companyId,
        'attio_valuation_id': attioValuationId,
      },
      body: data,
    });
  }
  /**
   * @param companyId
   * @param attioValuationId
   * @returns void
   * @throws ApiError
   */
  public static apiDashboardCompanyOperationsFulfillmentDelete(
    companyId: string,
    attioValuationId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/dashboard/company/{company_id}/operations/fulfillment/{attio_valuation_id}/',
      path: {
        'company_id': companyId,
        'attio_valuation_id': attioValuationId,
      },
    });
  }
  /**
   * @param companyId
   * @returns CompanyRequestedInformation
   * @throws ApiError
   */
  public static apiDashboardCompanyRequestedInformationRead(
    companyId: string,
  ): CancelablePromise<CompanyRequestedInformation> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/company/{company_id}/requested-information',
      path: {
        'company_id': companyId,
      },
    });
  }
  /**
   * @param cmdId
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiDashboardCurrentInformationRequestsRead(
    cmdId: string,
    page?: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/current-information-requests/{cmd_id}',
      path: {
        'cmd_id': cmdId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param cmdId
   * @returns any
   * @throws ApiError
   */
  public static apiDashboardDownloadFinalReportPdfRead(
    cmdId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/download-final-report-pdf/{cmd_id}',
      path: {
        'cmd_id': cmdId,
      },
    });
  }
  /**
   * @param cmdId
   * @returns any
   * @throws ApiError
   */
  public static apiDashboardDownloadValuationReportRead(
    cmdId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/download-valuation-report/{cmd_id}',
      path: {
        'cmd_id': cmdId,
      },
    });
  }
  /**
   * @returns FulfillmentAssignmentRule
   * @throws ApiError
   */
  public static apiDashboardFulfillmentAssignmentRulesList(): CancelablePromise<Array<FulfillmentAssignmentRule>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/fulfillment-assignment-rules/',
    });
  }
  /**
   * @param data
   * @returns FulfillmentAssignmentRule
   * @throws ApiError
   */
  public static apiDashboardFulfillmentAssignmentRulesCreate(
    data: FulfillmentAssignmentRule,
  ): CancelablePromise<FulfillmentAssignmentRule> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/fulfillment-assignment-rules/',
      body: data,
    });
  }
  /**
   * @param data
   * @returns FulfillmentAssignmentRule
   * @throws ApiError
   */
  public static apiDashboardFulfillmentAssignmentRulesPreview(
    data: FulfillmentAssignmentRule,
  ): CancelablePromise<FulfillmentAssignmentRule> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/fulfillment-assignment-rules/preview/',
      body: data,
    });
  }
  /**
   * @param id
   * @returns FulfillmentAssignmentRule
   * @throws ApiError
   */
  public static apiDashboardFulfillmentAssignmentRulesRead(
    id: string,
  ): CancelablePromise<FulfillmentAssignmentRule> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/fulfillment-assignment-rules/{id}/',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns FulfillmentAssignmentRule
   * @throws ApiError
   */
  public static apiDashboardFulfillmentAssignmentRulesUpdate(
    id: string,
    data: FulfillmentAssignmentRule,
  ): CancelablePromise<FulfillmentAssignmentRule> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/dashboard/fulfillment-assignment-rules/{id}/',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns FulfillmentAssignmentRule
   * @throws ApiError
   */
  public static apiDashboardFulfillmentAssignmentRulesPartialUpdate(
    id: string,
    data: FulfillmentAssignmentRule,
  ): CancelablePromise<FulfillmentAssignmentRule> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/dashboard/fulfillment-assignment-rules/{id}/',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @returns void
   * @throws ApiError
   */
  public static apiDashboardFulfillmentAssignmentRulesDelete(
    id: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/dashboard/fulfillment-assignment-rules/{id}/',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param fileType
   * @returns any
   * @throws ApiError
   */
  public static apiDashboardGenerateWorkboardImageSignedUrlRead(
    fileType: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/generate-workboard-image-signed-url/{file_type}',
      path: {
        'file_type': fileType,
      },
    });
  }
  /**
   * @param timeMin
   * @param timeMax
   * @param maxResults
   * @returns GoogleCalendarEventsQuery
   * @throws ApiError
   */
  public static apiDashboardGoogleCalendarEventsList(
    timeMin: string,
    timeMax?: string | null,
    maxResults: number = 100,
  ): CancelablePromise<Array<GoogleCalendarEventsQuery>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/google-calendar/events',
      query: {
        'time_min': timeMin,
        'time_max': timeMax,
        'max_results': maxResults,
      },
    });
  }
  /**
   * GraphQL proxy to Alexandria, keeping the x-api-key server-side.
   * Accepts a standard GraphQL POST body ({"query": "...", "variables": {...}})
   * and returns Alexandria's response verbatim, including GraphQL "errors",
   * so the frontend keeps normal GraphQL semantics.
   * @returns any
   * @throws ApiError
   */
  public static apiDashboardMarketDataGraphqlCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/market-data/graphql',
    });
  }
  /**
   * @param companyId
   * @param data
   * @returns FileStorageReferenceResponse
   * @throws ApiError
   */
  public static apiDashboardOperationsCompaniesFileStorageReferencePartialUpdate(
    companyId: string,
    data: CompanyFileStorageReferenceUpdate,
  ): CancelablePromise<FileStorageReferenceResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/dashboard/operations/companies/{company_id}/file-storage-reference/',
      path: {
        'company_id': companyId,
      },
      body: data,
    });
  }
  /**
   * @param cmdId
   * @param data
   * @returns FileStorageReferenceResponse
   * @throws ApiError
   */
  public static apiDashboardOperationsCompanyMeasurementDatesFileStorageReferencePartialUpdate(
    cmdId: string,
    data: CompanyMeasurementDateFileStorageReferenceUpdate,
  ): CancelablePromise<FileStorageReferenceResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/dashboard/operations/company-measurement-dates/{cmd_id}/file-storage-reference/',
      path: {
        'cmd_id': cmdId,
      },
      body: data,
    });
  }
  /**
   * @param cmdId
   * @returns any
   * @throws ApiError
   */
  public static apiDashboardOperationsCompanyMeasurementDatesSyncCompanyDocsCreate(
    cmdId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/operations/company-measurement-dates/{cmd_id}/sync-company-docs/',
      path: {
        'cmd_id': cmdId,
      },
    });
  }
  /**
   * Create or resolve Company, MeasurementDate, and CompanyMeasurementDate from Attio valuation
   * context, then get_or_create Fulfillment for that CMD (reviving soft-deleted rows).
   * Optional fulfillment fields are applied as a partial update.
   * @param data
   * @returns EnsureFulfillmentForAttioValuationRequest
   * @throws ApiError
   */
  public static apiDashboardOperationsEnsureFulfillmentForAttioValuationCreate(
    data: EnsureFulfillmentForAttioValuationRequest,
  ): CancelablePromise<EnsureFulfillmentForAttioValuationRequest> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/operations/ensure-fulfillment-for-attio-valuation/',
      body: data,
    });
  }
  /**
   * @param page A page number within the paginated result set.
   * @returns WorkboardDirectory
   * @throws ApiError
   */
  public static apiDashboardOperationsReportFilesWorkboardDirectoriesList(
    page?: number,
  ): CancelablePromise<Array<WorkboardDirectory>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/operations/report-files/workboard-directories/',
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param page A page number within the paginated result set.
   * @returns ReportBackupFile
   * @throws ApiError
   */
  public static apiDashboardOperationsReportFilesWorkboardFilesList(
    page?: number,
  ): CancelablePromise<Array<ReportBackupFile>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/operations/report-files/workboard-files/',
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param prefix
   * @param page A page number within the paginated result set.
   * @param root
   * @returns WorkboardPrefixExists
   * @throws ApiError
   */
  public static apiDashboardOperationsReportFilesWorkboardPrefixExistsList(
    prefix: string,
    page?: number,
    root?: string,
  ): CancelablePromise<WorkboardPrefixExists> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/operations/report-files/workboard-prefix-exists/',
      query: {
        'page': page,
        'prefix': prefix,
        'root': root,
      },
    });
  }
  /**
   * @param runId
   * @returns ValuationExtractionStatus
   * @throws ApiError
   */
  public static apiDashboardOperationsValuationExtractionRead(
    runId: string,
  ): CancelablePromise<ValuationExtractionStatus> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/operations/valuation-extraction/{run_id}/',
      path: {
        'run_id': runId,
      },
    });
  }
  /**
   * @param valuationId
   * @param page A page number within the paginated result set.
   * @returns LatestValuationExtractionRun
   * @throws ApiError
   */
  public static apiDashboardOperationsValuationsExtractionRunsLatestList(
    valuationId: string,
    page?: number,
  ): CancelablePromise<LatestValuationExtractionRun> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/operations/valuations/{valuation_id}/extraction-runs/latest/',
      path: {
        'valuation_id': valuationId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param valuationId
   * @param data
   * @returns StartValuationExtractionResponse
   * @throws ApiError
   */
  public static apiDashboardOperationsValuationsExtractionCreate(
    valuationId: string,
    data: StartValuationExtractionResponse,
  ): CancelablePromise<StartValuationExtractionResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/operations/valuations/{valuation_id}/extraction/',
      path: {
        'valuation_id': valuationId,
      },
      body: data,
    });
  }
  /**
   * @param valuationId
   * @param page A page number within the paginated result set.
   * @returns ValuationReportSelection
   * @throws ApiError
   */
  public static apiDashboardOperationsValuationsReportSelectionList(
    valuationId: string,
    page?: number,
  ): CancelablePromise<ValuationReportSelection> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/operations/valuations/{valuation_id}/report-selection/',
      path: {
        'valuation_id': valuationId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param valuationId
   * @param data
   * @returns ValuationReportSelection
   * @throws ApiError
   */
  public static apiDashboardOperationsValuationsReportSelectionUpdate(
    valuationId: string,
    data: ValuationReportSelection,
  ): CancelablePromise<ValuationReportSelection> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/dashboard/operations/valuations/{valuation_id}/report-selection/',
      path: {
        'valuation_id': valuationId,
      },
      body: data,
    });
  }
  /**
   * @param cmdId
   * @param data
   * @returns DraftFinalReportEmailResponse
   * @throws ApiError
   */
  public static apiDashboardOperationsDraftFinalReportEmailCreate(
    cmdId: string,
    data: DraftFinalReportEmailRequest,
  ): CancelablePromise<DraftFinalReportEmailResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/operations/{cmd_id}/draft-final-report-email/',
      path: {
        'cmd_id': cmdId,
      },
      body: data,
    });
  }
  /**
   * @param cmdId
   * @param page A page number within the paginated result set.
   * @returns ReportContact
   * @throws ApiError
   */
  public static apiDashboardOperationsReportContactsList(
    cmdId: string,
    page?: number,
  ): CancelablePromise<Array<ReportContact>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/operations/{cmd_id}/report-contacts/',
      path: {
        'cmd_id': cmdId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param cmdId
   * @param page A page number within the paginated result set.
   * @returns ReportBackupFile
   * @throws ApiError
   */
  public static apiDashboardOperationsReportFilesS3SearchList(
    cmdId: string,
    page?: number,
  ): CancelablePromise<Array<ReportBackupFile>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/operations/{cmd_id}/report-files/s3-search/',
      path: {
        'cmd_id': cmdId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static apiDashboardPublicCompaniesCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/public-companies',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static apiDashboardScalarOpinionsImportExtractedCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/scalar-opinions/import-extracted',
    });
  }
  /**
   * Get all fulfillments where the specified users are reviewers or preparers across all companies,
   * or fulfillments with no assigned reviewers/preparers, for the Model Reviewer/Preparer Dashboard
   *
   * Request Body:
   * - preparer_ids: List of preparer user IDs (optional). Example: [1, 2, 3]
   * - reviewer_ids: List of reviewer user IDs (optional). Example: [1, 2, 3]
   * - status_filter: Filter by assignment ('assigned', 'unassigned', or 'all')
   * - 'assigned': Returns fulfillments with at least one reviewer or preparer
   * - 'unassigned': Returns fulfillments with no reviewers/preparers assigned
   * - 'all': Returns all fulfillments
   * - Default: 'all'
   * - from_date: Filter by fulfillment creation date (optional). Example: '2026-01-01' (YYYY-MM-DD)
   * - to_date: Filter by fulfillment creation date (optional). Example: '2026-01-31' (YYYY-MM-DD)
   * - company: Filter by company name (optional). Example: 'Microsoft'
   *
   * Returns fulfillments that either:
   * - Have any of the specified users as reviewers or preparers (when status_filter is 'assigned' or 'all'), OR
   * - Have no assigned reviewers and no assigned preparers (when status_filter is 'unassigned', or included in 'all' with user IDs)
   * @param data
   * @returns UserFulfillmentRequest
   * @throws ApiError
   */
  public static apiDashboardUserModelsCreate(
    data: UserFulfillmentRequest,
  ): CancelablePromise<UserFulfillmentRequest> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/user/models/',
      body: data,
    });
  }
  /**
   * Distinct fulfillment model counts per user (reviewer or preparer) for the workboard
   * leaderboard. All-time requests only include users with at least 50 assigned models.
   * Date-filtered requests include every active user with at least one matching model.
   * Includes SLC and historic (non-Attio) models; excludes deleted fulfillments and
   * null model_status rows. Does not return full model payloads.
   *
   * Query params (optional, independent of workboard model table filters):
   * - from_date: Filter by fulfillment supporting_due_date (YYYY-MM-DD, inclusive)
   * - to_date: Filter by fulfillment supporting_due_date (YYYY-MM-DD, inclusive)
   * When either date is provided, fulfillments with null supporting_due_date are excluded
   * and the 50-model minimum is not applied. Omit both for all-time counts.
   * @param fromDate
   * @param toDate
   * @returns FulfillmentModelLeaderboardQuery
   * @throws ApiError
   */
  public static apiDashboardUserModelsLeaderboardList(
    fromDate?: string | null,
    toDate?: string | null,
  ): CancelablePromise<Array<FulfillmentModelLeaderboardQuery>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/user/models/leaderboard/',
      query: {
        'from_date': fromDate,
        'to_date': toDate,
      },
    });
  }
  /**
   * @param kind
   * @returns WorkboardEmailTemplateListResponse
   * @throws ApiError
   */
  public static apiDashboardWorkboardEmailTemplatesList(
    kind: 'onboarding' | 'renewal' | 'final_report',
  ): CancelablePromise<WorkboardEmailTemplateListResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/workboard-email-templates/',
      query: {
        'kind': kind,
      },
    });
  }
  /**
   * @param data
   * @param kind
   * @returns WorkboardEmailTemplate
   * @throws ApiError
   */
  public static apiDashboardWorkboardEmailTemplatesCreate(
    data: WorkboardEmailTemplate,
    kind: 'onboarding' | 'renewal' | 'final_report',
  ): CancelablePromise<WorkboardEmailTemplate> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/workboard-email-templates/',
      query: {
        'kind': kind,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @returns WorkboardEmailTemplate
   * @throws ApiError
   */
  public static apiDashboardWorkboardEmailTemplatesRead(
    id: string,
  ): CancelablePromise<WorkboardEmailTemplate> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/workboard-email-templates/{id}/',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns WorkboardEmailTemplate
   * @throws ApiError
   */
  public static apiDashboardWorkboardEmailTemplatesUpdate(
    id: string,
    data: WorkboardEmailTemplate,
  ): CancelablePromise<WorkboardEmailTemplate> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/dashboard/workboard-email-templates/{id}/',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns WorkboardEmailTemplate
   * @throws ApiError
   */
  public static apiDashboardWorkboardEmailTemplatesPartialUpdate(
    id: string,
    data: WorkboardEmailTemplate,
  ): CancelablePromise<WorkboardEmailTemplate> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/dashboard/workboard-email-templates/{id}/',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @returns void
   * @throws ApiError
   */
  public static apiDashboardWorkboardEmailTemplatesDelete(
    id: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/dashboard/workboard-email-templates/{id}/',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @returns WorkboardTask
   * @throws ApiError
   */
  public static apiDashboardWorkboardTasksList(): CancelablePromise<Array<WorkboardTask>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/workboard-tasks/',
    });
  }
  /**
   * @param data
   * @returns WorkboardTask
   * @throws ApiError
   */
  public static apiDashboardWorkboardTasksCreate(
    data: WorkboardTask,
  ): CancelablePromise<WorkboardTask> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/workboard-tasks/',
      body: data,
    });
  }
  /**
   * @param timeMin
   * @param timeMax
   * @param userIds Optional user IDs from the active workboard view. When provided, only tasks with an assignee or task manager in this list are returned. When omitted, only fully unassigned tasks (no assignees and no task managers) are returned.
   * @returns WorkboardTaskCalendarEventsQuery
   * @throws ApiError
   */
  public static apiDashboardWorkboardTasksCalendarEventsList(
    timeMin: string,
    timeMax?: string | null,
    userIds?: Array<number>,
  ): CancelablePromise<Array<WorkboardTaskCalendarEventsQuery>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/workboard-tasks/calendar/events',
      query: {
        'time_min': timeMin,
        'time_max': timeMax,
        'user_ids': userIds,
      },
    });
  }
  /**
   * @param id
   * @returns WorkboardTask
   * @throws ApiError
   */
  public static apiDashboardWorkboardTasksRead(
    id: string,
  ): CancelablePromise<WorkboardTask> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/workboard-tasks/{id}/',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns WorkboardTask
   * @throws ApiError
   */
  public static apiDashboardWorkboardTasksUpdate(
    id: string,
    data: WorkboardTask,
  ): CancelablePromise<WorkboardTask> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/dashboard/workboard-tasks/{id}/',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns WorkboardTask
   * @throws ApiError
   */
  public static apiDashboardWorkboardTasksPartialUpdate(
    id: string,
    data: WorkboardTask,
  ): CancelablePromise<WorkboardTask> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/dashboard/workboard-tasks/{id}/',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @returns void
   * @throws ApiError
   */
  public static apiDashboardWorkboardTasksDelete(
    id: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/dashboard/workboard-tasks/{id}/',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @param occurrenceDate Scheduled calendar date for this recurring task instance.
   * @returns WorkboardTaskOccurrence
   * @throws ApiError
   */
  public static apiDashboardWorkboardTasksOccurrencesRead(
    id: string,
    occurrenceDate: string,
  ): CancelablePromise<WorkboardTaskOccurrence> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/workboard-tasks/{id}/occurrences/',
      path: {
        'id': id,
      },
      query: {
        'occurrence_date': occurrenceDate,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns WorkboardTaskOccurrence
   * @throws ApiError
   */
  public static apiDashboardWorkboardTasksOccurrencesPartialUpdate(
    id: string,
    data: WorkboardTaskOccurrence,
  ): CancelablePromise<WorkboardTaskOccurrence> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/dashboard/workboard-tasks/{id}/occurrences/',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param viewType
   * @returns TableViewListResponse
   * @throws ApiError
   */
  public static apiDashboardWorkboardTableViewsList(
    viewType: 'models' | 'valuations',
  ): CancelablePromise<TableViewListResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/workboard/table-views/',
      query: {
        'view_type': viewType,
      },
    });
  }
  /**
   * @param data
   * @param viewType
   * @returns TableView
   * @throws ApiError
   */
  public static apiDashboardWorkboardTableViewsCreate(
    data: TableView,
    viewType: 'models' | 'valuations',
  ): CancelablePromise<TableView> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/dashboard/workboard/table-views/',
      query: {
        'view_type': viewType,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @returns TableView
   * @throws ApiError
   */
  public static apiDashboardWorkboardTableViewsRead(
    id: string,
  ): CancelablePromise<TableView> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/workboard/table-views/{id}/',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns TableView
   * @throws ApiError
   */
  public static apiDashboardWorkboardTableViewsUpdate(
    id: string,
    data: TableView,
  ): CancelablePromise<TableView> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/dashboard/workboard/table-views/{id}/',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns TableView
   * @throws ApiError
   */
  public static apiDashboardWorkboardTableViewsPartialUpdate(
    id: string,
    data: TableView,
  ): CancelablePromise<TableView> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/dashboard/workboard/table-views/{id}/',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @returns void
   * @throws ApiError
   */
  public static apiDashboardWorkboardTableViewsDelete(
    id: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/dashboard/workboard/table-views/{id}/',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param cmdId
   * @returns ValuationOpinionModule
   * @throws ApiError
   */
  public static apiDashboardRead(
    cmdId: string,
  ): CancelablePromise<ValuationOpinionModule> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/{cmd_id}',
      path: {
        'cmd_id': cmdId,
      },
    });
  }
  /**
   * @param cmdId
   * @param data
   * @returns ValuationOpinionModule
   * @throws ApiError
   */
  public static apiDashboardUpdate(
    cmdId: string,
    data: ValuationOpinionModule,
  ): CancelablePromise<ValuationOpinionModule> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/dashboard/{cmd_id}',
      path: {
        'cmd_id': cmdId,
      },
      body: data,
    });
  }
  /**
   * @param cmdId
   * @param data
   * @returns ValuationOpinionModule
   * @throws ApiError
   */
  public static apiDashboardPartialUpdate(
    cmdId: string,
    data: ValuationOpinionModule,
  ): CancelablePromise<ValuationOpinionModule> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/dashboard/{cmd_id}',
      path: {
        'cmd_id': cmdId,
      },
      body: data,
    });
  }
  /**
   * @param cmdId
   * @returns any
   * @throws ApiError
   */
  public static apiDashboardGpcCompSetRead(
    cmdId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/dashboard/{cmd_id}/gpc-comp-set',
      path: {
        'cmd_id': cmdId,
      },
    });
  }
}
